import styled from 'styled-components';
import { Banner, Container } from '@tryhackme/thm-ui-components';

export const StyledBanner = styled(Banner)`
  height: auto;

  img {
    width: 100%;
    object-fit: cover;
  }
`;

export const StyledSocialIconWrapper = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const StyledSocialIcon = styled.a<{ $isDark: boolean }>`
  display: flex;
  height: 2.4rem;
  fill: ${({ theme }) => theme.colors.text.lighter};
  transition: all 0.4s ease-in-out;
  width: 2.4rem;

  svg {
    fill: ${({ theme, $isDark }) => ($isDark ? theme.colors.grey[400] : theme.colors.grey[700])};
    transition: 150ms ease-in-out;
    width: 15rem;

    &:hover {
      transform: scale(1.1);
      fill: ${({ theme, $isDark }) => ($isDark ? theme.colors.grey[100] : theme.colors.black)};
    }
  }
`;

export const StyledHeaderCategory = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledHeaderSectionWrapper = styled.div`
  display: flex;
  max-width: 85.5rem;
  margin: 4.6rem auto 3rem;

  & > div:first-of-type {
    flex-basis: 90%;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    margin: 4.6rem 3.8rem 3rem 3.8rem;

    & > div:first-of-type {
      flex-basis: 90%;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin: 3rem 1.3rem 2.8rem 1.3rem;
  }
`;

export const StyledArticleTitle = styled.div`
  display: flex;
  height: auto;
  max-width: 85.5rem;
  margin: auto;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    margin: 0 3.8rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin: 0 1.3rem;
  }
`;

export const StyledPostWrapper = styled.article<{ $isDarkMode: boolean }>`
  display: flex;
  & > div:first-of-type {
    height: auto;
    max-width: 85.5rem;
    margin: auto;

    align-items: center;
    img,
    figure {
      height: inherit;
      width: 100%;
      object-fit: cover;
    }

    iframe {
      width: 100%;
      height: auto;
      min-height: 40rem;

      @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
        min-height: 33rem;
      }

      @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
        min-height: 20rem;
      }
    }
  }

  h1,
  h2,
  h3,
  h4 {
    color: ${({ theme, $isDarkMode }) => theme.colors[$isDarkMode ? 'white' : 'black']} !important;
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold} !important;
    line-height: 2.8rem !important;
    margin: 4.6rem 0 2rem 0 !important;
  }

  h1 {
    font-size: 3.2rem !important;

    @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
      font-size: 4.4rem !important;
    }

    @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
      font-size: 5.4rem !important;
    }
  }

  h2 {
    font-size: 2.4rem !important;
  }

  h3 {
    font-size: 2rem !important;
  }

  h4 {
    font-size: 1.8rem !important;
  }

  h5 {
    font-size: 2rem !important;
    line-height: 3rem !important;

    @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
      font-size: 2.4rem !important;
      line-height: 3.5rem !important;
    }
  }

  h6 {
    font-size: 2rem !important;

    @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
      font-size: 2.2rem !important;
    }
  }

  p,
  ul,
  li {
    margin-top: 1rem;
    margin-bottom: 3rem;
    color: ${({ theme }) => theme.colors.text.lighter};
    font-family: ${({ theme }) => theme.fonts.familySansPro};
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    font-size: 1.8rem;
    line-height: 2.4rem;
  }

  ul,
  li {
    margin: 1rem 1rem 1rem 2rem;
    list-style-type: disc;
  }

  center {
    text-align: -webkit-left !important;
  }

  a {
    color: ${({ theme }) => theme.colors.info.main};
  }

  a > button {
    background-color: ${({ theme }) => theme.colors.primary.main} !important;
    color: ${({ theme }) => theme.colors.secondary.main} !important;
    font-size: ${({ theme }) => theme.fonts.sizes.default} !important;
    line-height: 1.6rem;
    box-sizing: border-box !important;
    border: 0.1rem solid ${({ theme }) => theme.colors.primary.main} !important;
    border-radius: 0.4rem !important;
    padding: 1rem 1.6rem !important;
    transition: background-color 0.4s ease-in-out;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primary.lighter} !important;
      color: ${({ theme }) => theme.colors.text.main} !important;
    }
  }
  blockquote {
    color: ${({ theme }) => theme.colors.paragraph}!important;
    font-family: ${({ theme }) => theme.fonts.familySansPro} !important;
    font-size: ${({ theme }) => theme.fonts.sizes.default} !important;
    font-weight: ${({ theme }) => theme.fonts.weight.regular}!important;
    padding-left: 1.8rem;
    line-height: 1.8rem;
  }

  table,
  blockquote {
    height: auto;
    border-left: 0.4rem solid !important;
    border-left-color: ${({ theme }) => theme.colors.info.main} !important;
    margin: 4.6rem 0 !important;
  }

  colgroup > col {
    width: auto;
  }

  tbody > tr {
    line-height: 2.4rem;
  }

  tbody > tr > td {
    border-top: none !important;
    padding: 1.8rem 0 !important;
  }

  tbody > tr > td > p {
    margin-left: 1.8rem !important;
    margin-right: 1.8rem !important;
    line-height: 2.4rem !important;

    &:last-of-type > span {
      font-style: normal !important;
      color: ${({ theme }) => theme.colors.text.main}!important;
    }

    > span {
      font-family: ${({ theme }) => theme.fonts.familySansPro} !important;
      font-weight: ${({ theme }) => theme.fonts.weight.regular}!important;
      font-size: 1.8rem !important;
      color: ${({ theme }) => theme.colors.paragraph}!important;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    & > div:first-of-type {
      margin: 0;
      padding: 0 3.8rem;
      img {
        padding-right: 3.8rem;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    & > div:first-of-type {
      padding: 0 1.6rem;
      p {
        font-size: ${({ theme }) => theme.fonts.sizes.default};
      }
      img {
        padding-right: 1.6rem;
      }
    }
  }
`;

export const StyledAuthorWrapper = styled.div`
  max-width: 85.5rem;
  margin: 4.6rem auto 2.4rem;
  border-top: 0.2rem solid ${({ theme }) => theme.colors.border.light} !important;
  padding-top: 2.4rem;
  display: flex;

  & > div:first-of-type {
    flex-basis: 90%;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    margin: 4.6rem 3.8rem 2.4rem;
    & > div:first-of-type {
      flex-basis: 90%;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin: 4.6rem 1.3rem 2.4rem 1.3rem;
  }
`;

export const StyledAuthorSection = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
  line-height: 2.4rem;
  img {
    width: 4.6rem;
    height: 4.6rem;
    border-radius: 10rem;
  }
  display: flex;
  gap: 1.6rem;
`;

export const StyledRecommendedWrapper = styled(Container)`
  margin-top: 10rem;
  margin-bottom: 8rem;
  p {
    font-size: 1.8rem;
    line-height: 2.3rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    p {
      font-size: ${({ theme }) => theme.fonts.sizes.default};
      line-height: 2.4rem;
    }
  }
`;

export const StyledRecommendedSection = styled.div`
  margin-top: 4.6rem;
  display: grid;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) and (min-width: ${({ theme }) => theme.sizes.md}) {
    & > div:first-of-type {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;
